import { render, staticRenderFns } from "./CreateBrand.vue?vue&type=template&id=c955a1b8&scoped=true"
import script from "./CreateBrand.vue?vue&type=script&lang=js"
export * from "./CreateBrand.vue?vue&type=script&lang=js"
import style0 from "./CreateBrand.vue?vue&type=style&index=0&id=c955a1b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c955a1b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c955a1b8')) {
      api.createRecord('c955a1b8', component.options)
    } else {
      api.reload('c955a1b8', component.options)
    }
    module.hot.accept("./CreateBrand.vue?vue&type=template&id=c955a1b8&scoped=true", function () {
      api.rerender('c955a1b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brandname/CreateBrand.vue"
export default component.exports